// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React, { useState } from 'react'
import { node } from 'prop-types'
import Modal from 'react-modal'
import modalContext from './modalContext'

// TODO - split the providers up here to optimize children rerendering.
// TODO - allow for customization of the modal config

const ModalContextProvider = ({ children }) => {
  const [contextModalContent, setContextModalContent] = useState(null)

  const initialConfig = {
    onRequestClose: () => setContextModalContent(() => null),
  }

  const [contextModalConfig, setContextModalConfig] = useState(initialConfig)

  const openContextModal = (content, config) => {
    setContextModalConfig(() => ({
      ...initialConfig,
      ...config,
    }))
    setContextModalContent(() => content)
  }

  const closeContextModal = () => openContextModal(null)

  return (
    <modalContext.Provider value={{
      closeContextModal,
      openContextModal,
    }}>
      {children}
      {
        contextModalContent &&
        <Modal
          className={'modal-content-default padding-0'}
          isOpen={true}
          onRequestClose={contextModalConfig.onRequestClose}
          overlayClassName={'modal-overlay-default'}
          style={contextModalConfig.styles}>
          {contextModalContent}
        </Modal>
      }
    </modalContext.Provider>
  )
}

ModalContextProvider.propTypes = {
  children: node.isRequired,
}

export default ModalContextProvider
